import styled from "styled-components";

const StyledMembers = styled.div`
	padding: 40px;
	@media (max-width: ${({ theme }) => theme.responsive.mobile}) {
		padding: 40px 16px;
	}

	.sb-members-page {
		&__subscribers {
			&__heading {
				display: flex;
				align-items: center;
				justify-content: space-between;
				margin-bottom: 12px;
				flex-wrap: wrap;

				&__date-filter {
					position: relative;
					.ant-picker {
						.ant-picker-input {
							&:first-child {
								input {
									text-align: right;
								}
							}
						}
						@media (max-width: ${({ theme }) => theme.responsive.mobile}) {
							width: 100%;
						}
					}
					@media (max-width: ${({ theme }) => theme.responsive.mobile}) {
						width: 100%;
					}
					.custom-picker-range-popup-responsive {
						@media (max-width: ${({ theme }) => theme.responsive.mobile}) {
							position: absolute !important;
							top: 100% !important;
							left: 0 !important;
							right: 0 !important;
							transform: none !important;
							margin-top: 8px !important;
							width: 100vw !important;
							max-width: 100% !important;
							min-width: 100% !important;
							z-index: 9999 !important;

							.ant-picker-range-wrapper {
								[class^="ant-picker"],
								[class*=" ant-picker"] {
									font-size: 12px;
								}
							}
						}
					}
				}
			}

			&__charts {
				display: flex;
				align-items: stretch;
				justify-content: center;
				gap: 40px;
				@media (max-width: 968px) {
					flex-wrap: wrap;
				}
				&__donut {
					width: 50%;
				}

				&__stacked-bar-chart {
					width: 50%;
				}
				@media (max-width: 968px) {
					&__donut {
						width: 100%;
						flex: 1;
					}

					&__stacked-bar-chart {
						width: 100%;
						flex: 1;
					}
				}
			}

			&__table {
				position: relative;
				display: flex;
				align-items: center;
				justify-content: center;
				margin-top: 40px;
			}

			&__filter {
				padding: 32px 0px;
				&__element {
					border-radius: 100px;
					background-color: ${({ theme }) => theme.colors.iron};
					padding: 8px 12px;
					display: flex;
					align-items: center;
					justify-content: center;
					transition-duration: 500ms;
					transition-property: all;
					max-width: fit-content;
					height: 24px;
					p {
						max-width: 40vw;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
						font-size: 12px;
					}

					&--active {
						border: 1px solid ${({ theme }) => theme.colors.coral};
						background-color: var(--background-color);
						p {
							color: ${({ theme }) => theme.colors.coral};
						}
					}

					&:hover {
						box-shadow: 0 1px 2px -2px rgb(0 0 0 / 16%), 0 3px 6px 0 rgb(0 0 0 / 12%), 0 5px 12px 4px rgb(0 0 0 / 9%);
					}
				}
			}
		}
	}
`;

export default StyledMembers;

